import Manage from '@/pages/Manage'

export default {
    path: '/manage/set/:id',
    component: Manage,
    children: [
      {
        path: '',
        name: 'Manage',
        component: Manage
      },
     
    ]
}



// WEBPACK FOOTER //
// ./src/router/manage.js